import React from "react";
import "../styles.scss";
import MoreData from "components/Dashboards/OnlineDashboard/MoreData";
import ReportsCompletedToday from "components/Dashboards/OnlineDashboard/ReportsCompletedToday";
import ReportsStatus from "components/Dashboards/OnlineDashboard/ReportsStatus";
import UsersAppStatus from "components/Dashboards/Components/UsersAppStatus";
import SubTitle from "components/SubTitle";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { useGetOnlineDashboardQuery } from "features/api/dashboards/dashboardsApiSlice";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { onlineDashboardTypes } from "./types";
import { getTitle } from "../utils";

const OnlineDashboard = () => {
  const { t } = useTranslation();
  const controllerName = useGetUserData(LocalStorageKey.UserName);
  const {
    data,
    isLoading,
  }: {
    data: onlineDashboardTypes;
    isLoading: boolean;
  } = useGetOnlineDashboardQuery();

  return isLoading ? (
    <div className="loader-container">
      <Spinner animation="border" variant="primary" />
    </div>
  ) : (
    <div className="online-dashboard-container">
      <div className="right-screen">
        <div className="title-container">
          <SubTitle className="title">{getTitle(controllerName)}</SubTitle>
          <p className="sub-title">
            {t("deshboardLastCall")}
            {data.lastCall}
          </p>
        </div>
        <ReportsStatus data={data.reportsCountByStatuses} />
        <ReportsCompletedToday data={data.reportCompletedByRoles} />
        <MoreData data={data.extraDetailsDashboard} />
      </div>

      <div className="left-screen">
        <UsersAppStatus data={data.volunteerRegistrationData} />
      </div>
    </div>
  );
};
export default OnlineDashboard;
